<template>
  <div>
    <b-table striped hover small responsive fixed
    show-empty
    :empty-text="emptyText"
    :items="items"
    :filter-included-fields="filterOn"
    :filter-function="filterFunction"
    :fields="preparedFields"
    :filter="filter"
    :per-page="perPage"
    :editImageProp="editImage"
    :current-page="currentPage"
    selectable
    @row-selected="onRowSelected"
    @row-dblclicked="onRowDoubleClick"
    @row-contextmenu="onRowRightClick"
    @filtered="filtred"
    @sort-changed="SortCallBack"
    :no-local-sorting="isBackEndSort"
    select-mode="single">
      <template v-slot:cell(actions)="row">
        <i @click.stop="ClickOnEditButton(row)" v-bind:class=editClass v-if="isEdit"/>
        <i @click.stop="ClickOnDeleteButton(row)" class="danger fa fa-trash-alt fa-lg" v-if="isDelete"/>
        <i @click.stop="ClickOnPauseButton(row)" class="primary fa fa-pause fa-lg" v-if="isPause && !row.item.is_paused"/>
        <i @click.stop="ClickOnPlayButton(row)" class="danger fa fa-play fa-lg" v-if="isPlay && row.item.is_paused"/>
      </template>
      <template v-slot:cell(allUsers)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(allParam)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(settingsAdditionalVisible)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(is_deleted)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(is_payed)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(mailed)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(revoked)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(balanceRollover)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(display)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(fillIn)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(unallow_changing)="row">
        <b-form-checkbox v-model="row.item.unallow_changing"/>
      </template>
      <template v-slot:cell(is_scheduled)="data">
            <b-form-checkbox disabled switch  v-model="data.value"/>
      </template>
      <template v-slot:cell(use_connection)="data">
            <b-form-checkbox disabled switch  v-model="data.value"/>
      </template>
      <template v-if="!disableSettings" v-slot:head(burger_setting)>
        <i id="burgerSettings" :class="burgerSettingsIconClasses" />
        <b-popover @show="colSettingsClick" target="burgerSettings" triggers="hover" placement="bottom" id="column-settings-popover">
          <b-list-group  >
            <b-list-group-item :draggable="true" id="colSettings"
            style="margin:-2.2% -4% -3%; border:0px" class="d-flex "  v-for="item in selectedFields" :key="item.key">
              <b-row @click="() => {item.is_selected = !item.is_selected}" id="rowPopoverBurgerSetting">
                <b-col cols="1" style="margin-right:1%" >
                  <b-form-checkbox switch v-model="item.is_selected"/>
                </b-col>
                <b-col style="margin-top:1%">
                  {{item.label}}
                </b-col>
              </b-row>
            </b-list-group-item>

          </b-list-group>
        </b-popover>
      </template>
    </b-table>
  </div>

</template>

<style>
  #rowPopoverBurgerSetting {
    cursor: pointer;
  }
  #rowPopoverBurgerSetting:hover {
    font-weight: bold;
  }
  #column-settings-popover .arrow {
    display: none;
  }
</style>

<script>

export default {

  props: {
    isEdit: null,
    isDelete: null,
    isPause: null,
    isPlay: null,
    items: null,
    fields: null,
    filter: null,
    perPage: null,
    currentPage: null,
    editImageProp: null,
    isBackEndSort: false,
    disableSettings: false,
    editExpireIcon: null,
    filterOn: [],
    filterFunction: null

  },
  data () {
    return {
      prefixTableSettingsKey: 'ts_',
      currentDraggable: null,
      currentIndex: null,
      selectedFields: [],
      originFieldMap: {},
      preparedFields: null,
      emptyText: this.$i18n.t('Empty list'),
      deleteImage: require('@/assets/img/document_delete.png'),
      editImage: require('@/assets/img/document_edit.png')
    }
  },
  methods: {
    hash (val) {
      var hash = 0
      if (val.length === 0) return hash
      for (let i = 0; i < val.length; i++) {
        let char = val.charCodeAt(i)
        hash = ((hash << 5) - hash) + char
        hash = hash & hash // Convert to 32bit integer
      }
      return hash
    },
    colSettingsClick () {
      setTimeout(this.addListeners, 100)
    },
    addListeners () {
      document.querySelectorAll('[id="colSettings"]').forEach(el => {
        el.addEventListener('dragstart', this.dragstart)
        el.addEventListener('dragend', this.dragend)
        el.addEventListener('dragenter', this.dragenter)
      })
    },
    SortCallBack (ctx) {
      this.$emit('SortCallBack', ctx)
    },
    filtred (filteredItems) {
      this.$emit('Filtred', filteredItems)
    },
    onRowRightClick (item, idx, evt) {
      evt.preventDefault()
      this.$emit('ClickOnRightMouse', item)
    },
    onRowDoubleClick (item, index, event) {
      this.$emit('ClickOnEditButton', item)
    },
    pagination () {
      this.$emit('input', this.items.length)
    },
    ClickOnEditButton (row) {
      this.$emit('ClickOnEditButton', row.item)
    },
    ClickOnDeleteButton (row) {
      this.$emit('ClickOnDeleteButton', row.item)
    },
    ClickOnPauseButton (row) {
      this.$emit('ClickOnPauseButton', row.item)
    },
    ClickOnPlayButton (row) {
      this.$emit('ClickOnPlayButton', row.item)
    },
    onRowSelected (selected) {
      if (selected.length) { this.$emit('RowSelected', selected[0]) } else { this.$emit('RowSelected', null) }
    },
    dragstart (e) {
      this.currentDraggable = e.target.innerText
    },
    dragend (evt) {
      this.currentDraggable = null
      this.currentIndex = null
    },
    dragenter (evt) {
      evt.preventDefault()
      let startEl = this.selectedFields.find(el => {
        return el.label === this.currentDraggable
      })
      this.currentIndex = this.selectedFields.findIndex(el => el.label === evt.target.innerText)

      if (this.currentDraggable !== this.selectedFields[this.currentIndex].label) {
        this.selectedFields = this.selectedFields.filter(el => el.label !== this.currentDraggable)
        this.selectedFields.splice(this.currentIndex, 0, startEl)
      }
    },
    addFormatter (fields) {
      fields.forEach(el => {
        this.fields.forEach(field => {
          if (field.key === el.key) {
            el.formatter = field.formatter
          }
        })
      })
    }

  },
  mounted () {
    if (this.editImageProp) this.editImage = this.editImageProp
  },
  computed: {
    burgerSettingsIconClasses () {
      let color = (this.preparedFields.length - 1) !== this.fields.length ? 'danger' : 'primary'
      return color + ' fa fa-solid fa-bars fa-lg'
    },
    editClass () {
      return this.editExpireIcon ? 'primary fa fa-solid fa-hourglass-end fa-lg' : 'primary fa fa-edit fa-lg'
    }
  },
  watch: {
    items: function (val) {
      this.pagination()
    },
    selectedFields: {
      deep: true,
      handler: function (val) {
        this.preparedFields = []
        let key = ''
        for (let el of this.selectedFields) {
          if (el.is_selected) {
            this.preparedFields.push(this.originFieldMap[el.key])
          }
        }

        for (let el of this.fields) {
          key += el.key
        }
        key = this.prefixTableSettingsKey + this.hash(key)
        if (this.preparedFields.length > 0) {
          localStorage.setItem(key, JSON.stringify({preparedFields: this.preparedFields,
            selectedFields: this.selectedFields}))
        }
        this.addFormatter(this.preparedFields)
        if (!this.disableSettings) {
          this.preparedFields.unshift({key: 'burger_setting', label: 'Settings', thStyle: { width: '2%' }})
        }
      }
    },
    fields: {
      immediate: true,
      handler (newVal, old) {
        let tmp = JSON.parse(JSON.stringify(newVal))
        let tmp2 = JSON.parse(JSON.stringify(newVal))
        tmp2.forEach(el => { this.originFieldMap[el.key] = el })

        tmp.map(el => {
          if ('col_show_default' in el) {
            el.col_show_default ? el.is_selected = true : el.is_selected = false
          } else {
            el.is_selected = true
          }
        })
        this.selectedFields = JSON.parse(JSON.stringify(tmp))

        let key = ''
        tmp.forEach(el => { key += el.key })
        key = this.prefixTableSettingsKey + this.hash(key)
        tmp.unshift({key: 'burger_setting', label: 'Settings', thStyle: { width: '1.7%' }})
        if (localStorage.hasOwnProperty(key)) {
          this.preparedFields = JSON.parse(localStorage.getItem(key)).preparedFields
          this.selectedFields = JSON.parse(localStorage.getItem(key)).selectedFields
        } else {
          this.preparedFields = tmp
        }
        this.addFormatter(this.preparedFields)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/BasicTable.vue